/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-unknown-property */
/*
 * @category  Puma
 * @author    Beshoy Samuel <beshoy.samuel@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2024 Scandiweb, Inc (https://scandiweb.com)
 */

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import { STYLEGUIDE_POPUP } from 'Route/StyleGuide/StyleGuide.config';

import './StickySubscribeButton.style';

/**
 * @namespace Scandipwa/Component/StickySubscribeButton/Component */
export class StickySubscribeButtonComponent extends PureComponent {
    static propTypes = {
        activeOverlay: PropTypes.string.isRequired,
        stickySubscribeText: PropTypes.string.isRequired,
        setIsManuallyClosed: PropTypes.func.isRequired,
        isManuallyClosed: PropTypes.bool.isRequired,
        showSubscriptionOverlay: PropTypes.func.isRequired,
        isSignedIn: PropTypes.bool.isRequired
    };

    render() {
        const {
            activeOverlay,
            stickySubscribeText,
            setIsManuallyClosed,
            isManuallyClosed,
            showSubscriptionOverlay,
            isSignedIn
        } = this.props;

        if (isManuallyClosed || activeOverlay === STYLEGUIDE_POPUP || isSignedIn) {
            return null;
        }

        return (
            <div id="StickySubscribeButton" block="StickySubscribeButton" elem="Wrapper">
                <div block="StickySubscribeButton" elem="Outer">
                    <div block="StickySubscribeButton" elem="Inner">
                        <button block="StickySubscribeButton" elem="Button" onClick={ showSubscriptionOverlay }>
                            <div block="StickySubscribeButton" elem="Text">{ stickySubscribeText }</div>
                            <button class="Icon-Close" onClick={ setIsManuallyClosed } />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default StickySubscribeButtonComponent;
